/* eslint-disable react-hooks/exhaustive-deps */

import React from 'react';
import logo from '../assets/logo-dark.svg';
import googleLogo from '../assets/google-logo.svg'; // Add the path to your Google logo asset

const SignInModal = ({ isOpen, onClose, onSendLink, authError }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: '#ffffff',
        color: '#333',
        padding: '30px',
        borderRadius: '30px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        zIndex: 1000,
        width: '90%',
        maxWidth: '400px',
        textAlign: 'center',
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      <img
        src={logo}
        alt="Logo"
        style={{
          width: '50px',
          height: '50px',
          marginBottom: '10px',
        }}
      />
      <h2 style={{ marginBottom: '10px', fontSize: '20px', color: '#000' }}>
        Sign In to Proceed
      </h2>
      <p style={{ marginBottom: '20px', fontSize: '15px', color: '#555' }}>
        Hi there, 👋 Please sign in to continue.
      </p>
      {authError && (
        <p style={{ color: 'red', marginBottom: '20px', fontSize: '12px' }}>
          {authError}
        </p>
      )}
      <button
        onClick={onSendLink}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          padding: '10px',
          backgroundColor: '#fff',
          color: '#333',
          border: '1px solid #ddd',
          borderRadius: '6px',
          fontSize: '14px',
          fontWeight: 'bold',
          cursor: 'pointer',
          marginBottom: '10px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <img
          src={googleLogo}
          alt="Google"
          style={{
            width: '30px',
            height: '30px',
            marginRight: '8px',
          }}
        />
        Continue with Google
      </button>
      <button
        onClick={onClose}
        style={{
        //   width: '10%',
        //   padding: '10px',
          backgroundColor: '#fff',
          color: 'grey',
          border: '1px solid #fff',
          borderRadius: '6px',
          fontSize: '13px',
        //   fontWeight: 'bold',
          cursor: 'pointer',
        }}
      >
        Close
      </button>
    </div>
  );
};

export default SignInModal;
